import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-TW' // lang i18n
import "element-ui/lib/theme-chalk/index.css"; // 重要! 沒有的話 element ui 樣式會不正常
import '@/assets/style/theme/index.css'
import '@/assets/css/index.css' // css
import './assets/icons' // icon
import i18n from './lang/lang'
import VueJsonPretty from 'vue-json-pretty/lib/vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import { VueQuillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Fragment from 'vue-fragment' // 解決 el-menu el-submenu 中間有一層 div , collapse 無法渲染成功問題
// import VueTagsInput from '@johmun/vue-tags-input'; // vue-tags-input

// echarts
import * as echarts from "echarts"; // for vue-echarts v6
import EChartsVue from "vue-echarts";
import Announcement from '@/components/Announcement'// svg component

// import "echarts-gl";
// use echarts
Vue.component("v-chart", EChartsVue); // 註冊為 global component

Element.Dialog.props.closeOnClickModal.default = false // 全域禁止dialog點擊空白處關閉

Vue.use(Element, { locale }) // ElementUI設繁體

Vue.use(VueAxios, axios)
Vue.prototype.$axios = axios
// axios.defaults.baseURL = '/'
axios.defaults.withCredentials = true

Vue.component('vue-json-pretty',VueJsonPretty)

Vue.component('quill-editor', VueQuillEditor)

// 公告
Vue.component('announcement', Announcement)

// Vue.component('vue-tags-input', VueTagsInput)

Vue.use(Fragment.Plugin)



Vue.config.productionTip = false

// moment
// import moment from 'moment'
// moment.locale('zh-tw')
import moment from 'moment-timezone'
Vue.prototype.$moment = moment


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
